module.exports = __webpack_public_path__ + "img/logo bravo maps_291020.209991b0.jpg";